<template lang="pug" src="./single-news-event.pug"></template>

<script>
import api from 'api'
import axios from 'axios'
import Loader from 'components/loader/loader'
import FooterMain from 'components/footer/footer'

export default {
  data () {
    return {
      loading: true,
      props: ''
    }
  },
  created () {
    this.loading = true
    axios.get(api + '/wp/v2/posts?slug=' + this.$route.params.event)
      .then(response => {
        this.props = response.data[0]
        this.props ? this.loading = false : window.location.replace('/404')
      })
      .catch(e => {
        console.log(e)
      })
  },
  components: {
    Loader,
    FooterMain
  }
}
</script>



// WEBPACK FOOTER //
// single-news-event.vue?febb738c